import React, { useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput'

import API from '../../libs/api'

const api = new API()

const TimeSection = (props) => {
  const { date, sections, peopleCount, onChange, value, className, onUpdate, disabled } = props

  const timestamp = date.set({hour:0,minute:0,second:0,millisecond:0}).valueOf()

  useEffect(() => {
    api.on('activities/'+props.activityId+'/availableList', (val) => onUpdate(val))

    return () => {
      api.off('activities/'+props.activityId+'/availableList')
    }
  }, [])

  return <FormControl variant="outlined" className={className}>
    <InputLabel htmlFor="timesection-select">
    </InputLabel>
    <Select
      value={value}
      onChange={event => onChange(event.target.value)}
      input={
        <OutlinedInput name="timesection" id="timesection-select" />
      }
      disabled={disabled}
      MenuProps={{ style: { maxWidth: 800 } }}
    >
      <MenuItem value={-1} disabled style={{ minWidth: 200 }}>{I18n.t('chooseTimeSection')}</MenuItem>
      { sections.map(section =>
        {
          let booked = section[timestamp] ? (section[timestamp].booked || 0) : 0
          let fPeopleCount = parseFloat(peopleCount)
          return <MenuItem key={section.startTime} style={{ minWidth: 200 }} value={section.startTime} disabled={section.maxPeople && (fPeopleCount+booked) > section.maxPeople}>
            {section.startTime + (section.maxPeople > 0 ? ' ('+I18n.t('booked')+': '+booked+'/'+section.maxPeople+')' : '')}
          </MenuItem>
        })
      }
    </Select>
  </FormControl>
}
export default TimeSection


// WEBPACK FOOTER //
// ./src/containers/Activity/TimeSection.js